// Плавное обновление списка (приём FLIP). Когда свежие данные заменяют список
// (кнопка «обновить», возврат к списку, задание кто-то уже выполнил), карточки
// не перескакивают на новые места, а за 0,3 с доезжают до них; новые карточки
// мягко проявляются. Удалённые исчезают, а оставшиеся плавно закрывают промежуток.
//
//   const before = captureListPositions(container, oldKeys)   // до изменения DOM
//   playListMoves(container, newKeys, before, { animateNew })  // сразу после
//
// keys — ключи элементов в том же порядке, что и дети контейнера. Если число детей
// с ним не совпадает (что-то отрисовалось иначе), ничего не анимируется.
import { prefersReducedMotion } from './celebrate';

const MOVE_MS = 320;
const ENTER_MS = 380;
const EASING = 'cubic-bezier(.2, .8, .2, 1)';

function childrenMatch(container, keys) {
    return !!(container && keys && container.children && container.children.length === keys.length);
}

// Карточка, которая уже была на экране, не должна заново «появляться»: каскад
// в motion.css задан первым восьми (nth-child), и карточка, сдвинувшаяся, скажем,
// с 9-го места на 8-е, иначе мигнула бы с прозрачности 0,3.
function settleEntrance(el) {
    if (typeof el.getAnimations !== 'function') return;
    const animations = el.getAnimations();
    for (let i = 0; i < animations.length; i++) {
        if (animations[i].animationName === 'list-item-in') animations[i].finish();
    }
}

export function captureListPositions(container, keys) {
    if (!childrenMatch(container, keys)) return null;
    const positions = {};
    for (let i = 0; i < keys.length; i++) {
        positions[keys[i]] = container.children[i].getBoundingClientRect().top;
    }
    return positions;
}

export function playListMoves(container, keys, before, options) {
    if (!before || !childrenMatch(container, keys) || prefersReducedMotion()) return;
    const animateNew = !!(options && options.animateNew);
    const viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
    for (let i = 0; i < keys.length; i++) {
        const el = container.children[i];
        if (typeof el.animate !== 'function') return;     // старый WebView — просто без анимации
        const from = before[keys[i]];
        try {
            if (from !== undefined) settleEntrance(el);    // до замера: «появление» сдвигает на 8px
            const rect = el.getBoundingClientRect();
            const top = rect.top;
            const offscreen = (y) => y > viewportH || y + rect.height < 0;
            if (from === undefined) {
                // новая карточка; в обычном списке её проявляет CSS (list-item-in)
                if (animateNew && !offscreen(top)) {
                    el.animate([
                        { opacity: 0.3, transform: 'translateY(8px)' },
                        { opacity: 1, transform: 'translateY(0)' }
                    ], { duration: ENTER_MS, easing: EASING, fill: 'backwards' });
                }
                continue;
            }
            const delta = from - top;
            // карточки далеко за экраном не трогаем: их всё равно не видно
            if (Math.abs(delta) < 1 || (offscreen(top) && offscreen(from))) continue;
            el.animate([
                { transform: 'translateY(' + delta + 'px)' },
                { transform: 'translateY(0)' }
            ], { duration: MOVE_MS, easing: EASING });
        } catch (e) {
            return;
        }
    }
}
